const apiUrl = process.env.REACT_APP_API_URL;

export async function GetJavamons() {
    try {
        const response = await fetch(`${apiUrl}:8061/javamons`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            const data = await response.json();
            // Case 1: Direct Array
            if (Array.isArray(data)) return data;
            // Case 2: Wrapped in "json" property (String or Array)
            if (data && data.json) {
                if (Array.isArray(data.json)) return data.json;
                if (typeof data.json === 'string') {
                    try {
                        const parsed = JSON.parse(data.json);
                        if (Array.isArray(parsed)) return parsed;
                    } catch (e) {
                        console.error("Error parsing javamons json string", e);
                    }
                }
            }
            return [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching javamons", error);
        return [];
    }
}
